<template>
    <div class="container">
      <div class="row justify-content-md-center">
          <div class="col-sm-10 col-md-8">

            <div v-for="(blog,n) in topBlogs" class="row chart-item" @click.prevent="showBlog(blog)">
              <div class="col-sm-4 col-md-3 col-left">
                <div class="chartnum">
                  {{n+1}}
                </div>

              </div>
              <div class="col-sm-8 col-md-9 col-right">
                <a :href="getBlogUrl(blog)" >
                  <blog-avatar :blog="blog" :w="600" :h="150"/>
                  <h5 class="mt-2 mb-3 h3">{{blog.title}}</h5>
                </a>
              </div>
            </div>

          </div>
      </div>
      <loading-indicator name="blog.top20"/>
    </div>
</template>

<script>

  import BlogAvatar from '../ui/BlogAvatar.vue';
  import LoadingIndicator from "../ui/LoadingIndicator";

  export default {
    name: "Top20",
    props: {
        target: {
            default: '_blank'
        }
    },
    data(){
      return {
        isActive: false,
        topBlogs: []
      }
    },
    mounted() {
      this.isActive = true;

      this.$bus.$on('bloglist.exists', (data)=>{
        if(this.isActive) this.$bus.$emit('blog-modal.listExists', this.getNextPrevBlogs(data.currentBlog));
      });

      this.$api.getBlogTop20()
        .then((res)=>{
          this.topBlogs = res.data.blogs
        })
    },
    beforeDestroy() {
      this.isActive = false;
    },
    methods: {
      getBlogUrl(blog){
        return this.$router.resolve({name: 'BlogPage', params:{blogUrl:blog.url}}).href;
      },
      showBlog(blog){
        this.$bus.$emit('blog-modal.open', {blog});
      },
      getNextPrevBlogs(current){
        let last = null;
        let next = null;
        for(let i in this.topBlogs){
          const b = this.topBlogs[i];
          if(b === current){
            next = 1;
            continue;
          }
          if(next === 1){
            next = b;
            break;
          }
          last = b;
        }
        if(next === 1) next = null;
        return {
          nextBlog: next,
          prevBlog: last
        }
      }
    },
    components: {
      LoadingIndicator,
      BlogAvatar
    }
  }
</script>

<style lang="sass" scoped>

    @import '../../assets/sass/vars.scss'
    @import '../../../node_modules/bootstrap/scss/_functions.scss'
    @import '../../assets/bootstrap/variables.scss'

    .chartnum
        width: 1.2em
        font-size: 3em
        background-color: $colorPrimary
        color: #FFF
        width: 80px
        height: 80px
        text-align: center

    .col-left, .col-right
      padding-top: 15px

    .chart-item
        background-color: #FFF
        margin-bottom: 2em
        border: 1px solid #DDD
        cursor: pointer

        a
          color: $gray-800


        &:hover
            box-shadow: 0 4px 10px rgba(0,0,0,0.3)
            transition: box-shadow 200ms ease-in-out


</style>



// WEBPACK FOOTER //
// src/components/blogs/Top20.vue